import { InputRichText } from '@dixa/lib-shared-habla';
import { Channel } from 'lib-shared-types-channels';
import { memo } from 'react';

import { CopilotAction, CopilotDropdown } from 'components/copilotDropdown';
import { useCopilotTrial } from 'utils/useCopilotTrial';

import { EditorCopilotDropdownContext } from './editorCopilotDropdownContext';

export const DEFAULT_PINNED_STATE = {
  improveReply: false,
  improveReplyMatchStyleGuide: false,
  checkSpellingAndGrammar: false,
  translateToConversationLanguage: true,
  expandText: true,
};

interface EditorCopilotDropdownProps {
  editorCopilotActions: Record<string, CopilotAction>;
  channel?: Channel;
}

/**
 * Represents a dropdown component designed to be integrated into a rich text
 * editor's toolbar as an addon, providing AI-powered functionalities to enhance
 * and refine the content within the editor.
 */
export const EditorCopilotDropdown = memo(function EditorCopilotDropdown({
  editorCopilotActions,
  channel,
}: EditorCopilotDropdownProps): JSX.Element | null {
  const { hasCopilot } = useCopilotTrial();

  if (!hasCopilot) {
    return null;
  }

  return (
    <EditorCopilotDropdownContext.Provider value={{ channel }}>
      <div>
        <CopilotDropdown actions={editorCopilotActions} fixed noArrow noStyle>
          <InputRichText.ToolbarButton icon="ai" />
        </CopilotDropdown>
      </div>
    </EditorCopilotDropdownContext.Provider>
  );
});
